import React from "react"
import { ADD } from "../../include/constant"
import SlideForm from "../common/SlideForm"
import SuperAdminHeader from "./Header"

const SuperAdminAddSlide = () => {
    return <div className="fixed-top-bar">
        <SuperAdminHeader />
        <SlideForm
            title="Add Slide"
            type={ADD}
        />
    </div>
}

export default SuperAdminAddSlide